import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DxScrollViewComponent, DxTreeViewComponent } from 'devextreme-angular';
import * as events from 'devextreme/events';
import { NavigationMenu, ScreenService } from '@wissenswerft/organizational-structure';
import { UserService } from '@wissenswerft/core/authentication';
import { GeoDsLoginInfo } from 'libs/core/authentication/src/lib/models/profile-info.model';
import { IToastAnimation, ToastAnimationShowType, ToastComponent, ToastType } from '@wissenswerft/ww-library';
import { AppService } from './services/app.service';
import deMessages from "devextreme/localization/messages/de.json";
import enMessages from "devextreme/localization/messages/en.json";
import { forkJoin, Observable, Subscription } from 'rxjs';
import { DataService, ObjectKeys } from './services/data.service';
import { loadMessages, locale } from 'devextreme/localization';
import { ResourceManagerService } from 'libs/core/resources/src/lib/resource-manager.service';
import { FavoriteListComponent } from './core/favorite-list/favorite-list.component';
import { GeoDsCoreDataService, QueryColumnSortOrder } from '@wissenswerft/core/data';

export enum NavigationSvg {
  DASHBOARD = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M57,20H20V63H57ZM51,57H26V26H51Z"/><path class="cls-1" d="M63,20V51h37V20ZM94,45H69V26H94Z"/><path class="cls-1" d="M20,69v31H57V69ZM51,94H26V75H51Z"/><path class="cls-1" d="M63,57v43h37V57ZM94,94H69V63H94Z"/></svg>',
  MODULE = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M101,56.24V30.84L79,18.14l-19,11-19-11L19,30.84v25.4l19,11V89.14l22,12.72L82,89.14V67.23ZM38,60.31,25,52.78v-15l13,7.5Zm-10-27.75,13-7.49,13,7.51-13,7.5Zm29,5.22v15l-13,7.5v-15Zm0,55.43L44,85.68v-15l13,7.51Zm-10-27.74L60,58l13,7.48L60,73ZM63,37.78l13,7.49v15l-13-7.5Zm0,55.43v-15l13-7.51v15Zm3-60.63,13-7.51,13,7.49L79,40.08ZM82,45.27l13-7.5v15L82,60.31Z"/></svg>',
  LIBRARY = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M96.29,64.36a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41c0-3.05,1.29-4.32,1.85-4.72h0a3,3,0,0,0,1.37-2.86,2.73,2.73,0,0,0-1.82-2.29c-.29-.22-1.4-1.29-1.4-4.43s1.29-4.32,1.85-4.72h0a3,3,0,0,0-.64-5.22L62.47,17.22a3,3,0,0,0-2.87.35L26.65,41.34h0c-1.3.94-4.34,3.76-4.34,9.58a12.5,12.5,0,0,0,2,7.25,12.52,12.52,0,0,0-2,7,12.56,12.56,0,0,0,2,7.26,12.46,12.46,0,0,0-2,7c0,7.51,4.38,9.67,4.88,9.9l.1,0,33.18,13.32a2.94,2.94,0,0,0,1.12.22,3,3,0,0,0,1.76-.57l33-23.77a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41C94.44,66,95.73,64.76,96.29,64.36Zm-67.11-17L56.76,58.39a13,13,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,55.37c-.27-.21-1.42-1.26-1.42-4.45A6.74,6.74,0,0,1,29.18,47.31Zm.32,8,.14.06-.12-.05Zm-.33,6.34L56.76,72.69a13.06,13.06,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,69.67c-.27-.21-1.42-1.26-1.42-4.45A6.81,6.81,0,0,1,29.17,61.62Zm.35,8h0l.12,0ZM90,61.48,62,81.69a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,55.71A12.59,12.59,0,0,0,90,61.48Zm0-14.3L62,67.39a8.09,8.09,0,0,1-.52-3.14c0-3.06,1.29-4.32,1.85-4.72L88.46,41.4A12.6,12.6,0,0,0,90,47.18ZM61.77,23.4,88.36,34.08,61.17,53.7,34.57,43ZM28.3,79.52a6.81,6.81,0,0,1,.87-3.6L56.76,87a13.06,13.06,0,0,0-1.27,5.86c0,.53,0,1,.06,1.5L29.61,83.93C29.51,83.85,28.3,82.76,28.3,79.52ZM62,96a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,70A12.55,12.55,0,0,0,90,75.78Z"/></svg>',
  DOCUMENTS = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:white;}</style></defs><path class="cls-1" d="M96.29,64.36a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41c0-3.05,1.29-4.32,1.85-4.72h0a3,3,0,0,0,1.37-2.86,2.73,2.73,0,0,0-1.82-2.29c-.29-.22-1.4-1.29-1.4-4.43s1.29-4.32,1.85-4.72h0a3,3,0,0,0-.64-5.22L62.47,17.22a3,3,0,0,0-2.87.35L26.65,41.34h0c-1.3.94-4.34,3.76-4.34,9.58a12.5,12.5,0,0,0,2,7.25,12.52,12.52,0,0,0-2,7,12.56,12.56,0,0,0,2,7.26,12.46,12.46,0,0,0-2,7c0,7.51,4.38,9.67,4.88,9.9l.1,0,33.18,13.32a2.94,2.94,0,0,0,1.12.22,3,3,0,0,0,1.76-.57l33-23.77a3,3,0,0,0-.54-5.17s-1.31-1-1.31-4.41C94.44,66,95.73,64.76,96.29,64.36Zm-67.11-17L56.76,58.39a13,13,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,55.37c-.27-.21-1.42-1.26-1.42-4.45A6.74,6.74,0,0,1,29.18,47.31Zm.32,8,.14.06-.12-.05Zm-.33,6.34L56.76,72.69a13.06,13.06,0,0,0-1.27,5.86c0,.52,0,1,.06,1.49L29.72,69.67c-.27-.21-1.42-1.26-1.42-4.45A6.81,6.81,0,0,1,29.17,61.62Zm.35,8h0l.12,0ZM90,61.48,62,81.69a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,55.71A12.59,12.59,0,0,0,90,61.48Zm0-14.3L62,67.39a8.09,8.09,0,0,1-.52-3.14c0-3.06,1.29-4.32,1.85-4.72L88.46,41.4A12.6,12.6,0,0,0,90,47.18ZM61.77,23.4,88.36,34.08,61.17,53.7,34.57,43ZM28.3,79.52a6.81,6.81,0,0,1,.87-3.6L56.76,87a13.06,13.06,0,0,0-1.27,5.86c0,.53,0,1,.06,1.5L29.61,83.93C29.51,83.85,28.3,82.76,28.3,79.52ZM62,96a8,8,0,0,1-.52-3.14c0-3,1.29-4.32,1.85-4.72L88.46,70A12.55,12.55,0,0,0,90,75.78Z"/></svg>',
  COMPANY = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:828294;}</style></defs><path class="cls-1" d="M83.22,41.66v-12.73l-19.65-8.93-30.36,8.93v19.47l-16,4.71v46.89H99.22V48.93l-16-7.27Zm-22.01,52.34h-22v-14l-10,1v13h-6V57.6l23.91-7.03,14.09,6.41v37.03Zm16,0h-10V53.11l-19.65-8.93-8.36,2.46v-13.22l23.91-7.03,14.1,6.41v61.21Zm16,0h-10V48.25l10,4.55v41.2Z"/><polygon class="cls-1" points="47.12 63.18 55.21 65.85 55.21 60.26 47.12 56.59 47.12 63.18"/><polygon class="cls-1" points="47.12 75.81 55.21 77.49 55.21 71.51 47.12 69.22 47.12 75.81"/><polygon class="cls-1" points="47.12 88.33 55.21 88.33 55.21 82.96 47.12 81.74 47.12 88.33"/></svg>',
  HOME = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;fill-rule:evenodd;}</style></defs><path class="cls-1" d="M98.72,71,93,65.31V96H66V75H54V96H27V65.31L21.28,71,17,66.76,60,24l43,42.77ZM33,59.34V90H48V69H72V90H87V59.34L60,32.48Z"/></svg>',
  MEASURES = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M15.76,57.84l46.4,46.4L85.27,81.13l-46.4-46.4Zm46.4,37.92L24.24,57.84,38.87,43.21l4.19,4.19-4.2,4.2,4.24,4.25,4.2-4.21,4.19,4.19L47.29,60l4.24,4.24,4.21-4.2,4.18,4.18-4.2,4.21L60,72.71l4.21-4.2,4.19,4.19-4.21,4.2,4.25,4.24,4.2-4.2,4.19,4.19Z"/><polygon class="cls-1" points="97.88 60.03 93.68 64.24 55.76 26.32 59.97 22.12 55.72 17.88 43.08 30.53 47.32 34.77 51.52 30.57 89.44 68.48 85.23 72.68 89.47 76.92 102.12 64.28 97.88 60.03"/></svg>',
  AUDIT = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M101.43,82.58c1.92-2.75,3.05-6.09,3.05-9.7,0-8.36-6.04-15.29-13.99-16.72V21.22H54.31l-24.81,24.81v55.19h61v-11.63c2.45-.44,4.72-1.4,6.69-2.77l8.4,8.4,4.24-4.24-8.4-8.4ZM53.5,30.51v14.71h-14.71l14.71-14.71Zm-18,64.71V51.22h24V27.22h25v28.93c-7.96,1.41-14.01,8.35-14.01,16.72s6.05,15.31,14.01,16.72v5.63H35.5Zm51.99-11.35c-6.07,0-11-4.93-11-11s4.93-11,11-11,11,4.93,11,11-4.93,11-11,11Z"/><path class="cls-1" d="M68.5,58.22h-26.01v6h22.61c.84-2.17,1.99-4.19,3.39-6Z"/><path class="cls-1" d="M63.49,72.87c0-.9,.05-1.78,.15-2.65h-21.14v6h21.23c-.15-1.1-.24-2.21-.24-3.35Z"/><path class="cls-1" d="M42.5,82.22v6h26.56c-1.5-1.8-2.74-3.82-3.67-6h-22.89Z"/></svg>',
  TASK = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fill:#828294;}</style></defs><path class="cls-1" d="M40,57h18v-18h-18v18Zm6-12h6v6h-6v-6Z"/><rect class="cls-1" x="64" y="39" width="16" height="6"/><rect class="cls-1" x="64" y="51" width="10" height="6"/><path class="cls-1" d="M40,81h18v-18h-18v18Zm6-12h6v6h-6v-6Z"/><rect class="cls-1" x="64" y="63" width="16" height="6"/><rect class="cls-1" x="64" y="75" width="10" height="6"/><path class="cls-1" d="M69.5,20l-1.5-6h-16l-1.5,6H28V100H92V20h-22.5Zm-12.81,0h6.63l1.5,6h-9.62l1.5-6Zm29.31,74H34V26h12v6h28v-6h12V94Z"/></svg>',
  REPORTS = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fillwhite;}</style></defs><polygon class="cls-1" points="18.5 26 24.5 26 24.5 94 18.5 94 18.5 100 36.5 100 36.5 94 30.5 94 30.5 26 36.5 26 36.5 20 18.5 20 18.5 26"/><polygon class="cls-1" points="59.43 76.08 68.5 85.16 84.57 69.08 80.33 64.84 68.5 76.67 63.67 71.84 59.43 76.08"/><path class="cls-1" d="M69.74,20H42.5v80h59V51.76ZM71.5,30.24,91.26,50H71.5ZM95.5,94h-47V26h17V56h30Z"/></svg>',
  FAVORITE = '<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.cls-1{fillwhite}</style></defs><path class="cls-1" d="M76.56,24c-4.16,0-11.01,1.33-16.56,8.15-5.55-6.81-12.4-8.15-16.56-8.15-17.76,0-28.7,16.93-22.25,36.77,7.34,22.56,33.72,35.23,38.81,35.23s31.46-12.67,38.81-35.23c6.46-19.83-4.49-36.77-22.25-36.77Zm16.54,34.91c-6.04,18.56-28.08,30.22-33.1,31.07-5.02-.84-27.06-12.51-33.1-31.07-2.7-8.3-1.91-16.28,2.18-21.91,3.28-4.51,8.38-7,14.36-7,3.83,0,9.34,1,15.3,10.14,.47,.72,.89,1.5,1.26,2.3,.38-.8,.79-1.58,1.26-2.3,5.96-9.14,11.47-10.14,15.3-10.14,5.98,0,11.09,2.49,14.36,7,4.09,5.63,4.88,13.61,2.18,21.91Z"/></svg>'
}

export enum DxDrawerRevealMode {
  slide = 'slide',
  expand = 'expand'
}

export enum DxDrawerOpenedStateMode {
  overlap = 'overlap',
  shrink = 'shrink',
  push = 'push'
}

@Component({
  selector: 'digitalization-tool-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(DxScrollViewComponent, { static: true }) scrollView: DxScrollViewComponent;
  @ViewChild("treeview") menu: DxTreeViewComponent;
  @ViewChild('toast', { static: false }) dxToast: ToastComponent;
  @ViewChild('favorites') favorites: FavoriteListComponent
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter((cl) => this.screen.sizes[cl]).join(' ');
  }
  @Output() openMenu = new EventEmitter<MouseEvent>();
  public isFavoriteOpen = false;
  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;
    if (!this.menu.instance) {
      return;
    }
    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }
  @Input() set selectedItem(value: string) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }
    this.menu.instance.selectItem(value);
  }
  title = 'digitalization-tool';
  public iunitlogo = `<svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536.78 335.52"><defs><style>.cls-1{fill:#fff;}</style></defs><title>iunitgroup-gruppenlogo_w</title><path class="cls-1" d="M197.23,278.6c1.29.95,3.9,1.45,5.93,1.45a15.85,15.85,0,0,0,12.3-5.49c3.76-4.35,5.64-11.15,5.64-18.31,0-9.41-4.77-12.67-9.91-12.67-5.57,0-8.61,3-10.79,6.15h-.71l.71-5.42a8.86,8.86,0,0,0-2.46-.29,13.67,13.67,0,0,0-6.65,1.66,8.15,8.15,0,0,0-1.3,3.69l5.13-.58L189.33,295a9.67,9.67,0,0,0,2.68.29,22.46,22.46,0,0,0,3.47-.29ZM200,254.36c1.53-2.89,5-5.86,8.25-5.86,4.42,0,6.51,3.4,6.51,9.48,0,5.43-.86,10.93-3.61,14.19a10.13,10.13,0,0,1-8.25,3.54,14.9,14.9,0,0,1-5.36-1Zm-26.8,20.12a15.92,15.92,0,0,0,1.81,5.57,32.71,32.71,0,0,0,8.54-1.66,9.9,9.9,0,0,0,1.16-4.05l-5.44.5a5.87,5.87,0,0,1-.35-1.37l3.33-29.16a17.7,17.7,0,0,0-2.9-.29,14.67,14.67,0,0,0-6.88,1.59,8.42,8.42,0,0,0-1.3,3.76l5-.58-2.74,20.91a10.41,10.41,0,0,1-8.69,5.43c-3.69,0-5.06-2.38-5.06-6.15,0-2.89,1.66-17,2.67-24.67a17.73,17.73,0,0,0-3-.29,16,16,0,0,0-7.16,1.66,7.89,7.89,0,0,0-1.31,3.69l5.28-.58c-.72,4.05-2.89,17.66-2.89,22.43,0,6.88,4.19,8.83,8.32,8.83,5.43,0,9-2.24,11.22-5.57Zm-43.64,1.31c-4.19,0-6.36-4-6.36-10.28,0-4.34.5-8.61,2.17-11.94s4.55-5.79,8.18-5.79c4.12,0,6.29,4.12,6.29,10,0,4.7-.87,9.62-2.82,13-1.74,3-4.27,5-7.46,5m-.72,4.26a15.38,15.38,0,0,0,12.74-6.58c2.89-4.13,4.49-10,4.49-16.35,0-8.69-4.57-13.54-11.94-13.54-5.72,0-10.57,3.11-13.61,8a28,28,0,0,0-3.62,14.62c0,9.12,4.2,13.89,11.94,13.89m-27.57-28.44.94-7.3a8.86,8.86,0,0,0-2.46-.29,13.71,13.71,0,0,0-6.66,1.66,8.15,8.15,0,0,0-1.3,3.69l5.36-.58-3.91,29.89a9.3,9.3,0,0,0,2.68.29,23.77,23.77,0,0,0,3.47-.29l2.24-22.21c1.74-4.71,5-7.1,8.54-7.1a8.69,8.69,0,0,1,4.92,1.45,12.5,12.5,0,0,0,.51-3.33,10,10,0,0,0-.51-3.26,8.77,8.77,0,0,0-3.47-.65c-5,0-8.25,3.91-9.63,8ZM77.39,269.27c-1.88,3.4-5,5.5-8,5.5-3.84,0-6.3-2.67-6.3-8.68,0-4,.87-9.77,3.11-13.31,1.89-2.9,4.92-5.36,8.83-5.36a10.47,10.47,0,0,1,4.85,1.15Zm8.47-22.43a18.36,18.36,0,0,0-10.64-3.26,16.52,16.52,0,0,0-13.53,7.09c-3.11,4.27-4.78,10.21-4.78,16.21,0,9.12,4.06,12.81,9.55,12.81a12.88,12.88,0,0,0,10.64-5.86h.73a44.29,44.29,0,0,0-1.38,6.22c-1,6.66-3.69,11.44-10.21,11.44a22.32,22.32,0,0,1-11.14-3.55,9.1,9.1,0,0,0-.21,1.95,10.82,10.82,0,0,0,.86,4.42,29.84,29.84,0,0,0,10.36,1.95c11.79,0,15.48-9.05,16.64-20Z"/><path class="cls-1" d="M204.89,192.83a17.45,17.45,0,0,0-4.12,1.23,10,10,0,0,0-1.38,3.76h5.22c-1.23,7.23-3.12,19.83-3.12,23.88,0,4.48,1.95,7.16,6.66,7.16a18.3,18.3,0,0,0,8.4-2.31,9.31,9.31,0,0,0,.93-3.84,17.81,17.81,0,0,1-6.15,1.38c-3,0-3.83-1.88-3.47-5.72l2-20.55H220.3a17.72,17.72,0,0,0,.3-2.9,8.11,8.11,0,0,0-.08-1.3h-10l1.08-10.35a10.11,10.11,0,0,0-4.63,1.16Zm-16.13-16.36a3.89,3.89,0,0,0-4,3.78v.22c0,2.82,1.38,4.27,4,4.27,2.24,0,3.91-1.59,3.91-4.27a3.66,3.66,0,0,0-3.32-4,3.85,3.85,0,0,0-.59,0m-4.71,21.13-3.76,25.91c0,1.23,1.16,3.76,2.53,5.35a32,32,0,0,0,8.62-1.66,10.3,10.3,0,0,0,1.15-4.06l-5.64.58a4.37,4.37,0,0,1-.37-1.23l3.63-29.38a20,20,0,0,0-3-.28,16,16,0,0,0-7.16,1.66,8.15,8.15,0,0,0-1.3,3.69ZM149.17,199l.65-5.87a8.85,8.85,0,0,0-2.46-.28,13.67,13.67,0,0,0-6.65,1.66,8.15,8.15,0,0,0-1.3,3.69l5.27-.58-4,29.89a9.3,9.3,0,0,0,2.68.29,23.77,23.77,0,0,0,3.47-.29l2.68-23.81c1.37-2.89,4.84-6.51,8.83-6.51,3.47,0,4.92,2.46,4.92,6.22s-1.89,14.83-2.83,20.12c0,1.23,1.16,3.76,2.53,5.35a29.67,29.67,0,0,0,8.55-1.66,10,10,0,0,0,1.15-4.06l-5.57.58a3.79,3.79,0,0,1-.36-1.23c.43-3.32,2.68-16.78,2.68-21.13,0-7.23-4.06-9-8.4-9A12,12,0,0,0,149.9,199Zm-27.64,24.31a15.92,15.92,0,0,0,1.81,5.57,32.71,32.71,0,0,0,8.54-1.66,10,10,0,0,0,1.16-4.06l-5.43.51a5.43,5.43,0,0,1-.36-1.37l3.33-29.17a18.86,18.86,0,0,0-2.9-.28,14.63,14.63,0,0,0-6.87,1.59,8.42,8.42,0,0,0-1.3,3.76l5-.58-2.75,20.92a10.43,10.43,0,0,1-8.69,5.42c-3.69,0-5.06-2.38-5.06-6.15,0-2.9,1.67-17,2.68-24.68a20,20,0,0,0-3-.28,16,16,0,0,0-7.16,1.66,7.89,7.89,0,0,0-1.31,3.69l5.29-.58c-.73,4.06-2.9,17.66-2.9,22.43,0,6.88,4.2,8.83,8.32,8.83,5.43,0,9-2.24,11.22-5.57ZM92.3,210.7a21.39,21.39,0,0,0,.36-3.91,9.92,9.92,0,0,0-.07-1.44H76.88a19.16,19.16,0,0,0-1,5.35ZM66.68,176.47a3.88,3.88,0,0,0-4,3.76v.24c0,2.82,1.38,4.27,4,4.27,2.25,0,3.91-1.59,3.91-4.27a3.66,3.66,0,0,0-3.32-4,3.85,3.85,0,0,0-.59,0M62,197.6l-3.77,25.91c0,1.23,1.16,3.76,2.54,5.35a32,32,0,0,0,8.61-1.66,10,10,0,0,0,1.15-4.06l-5.64.58a4.45,4.45,0,0,1-.36-1.23l3.62-29.38a20,20,0,0,0-3-.28A16,16,0,0,0,58,194.49a7.89,7.89,0,0,0-1.31,3.69Z"/><rect class="cls-1" x="243.18" y="192.7" width="36.01" height="86.12"/><rect class="cls-1" x="293.4" y="166.29" width="36.01" height="112.54"/><rect class="cls-1" x="393.85" y="184.65" width="36.02" height="94.18"/><rect class="cls-1" x="444.08" y="56.69" width="36.01" height="222.12"/><rect class="cls-1" x="343.63" y="78.99" width="36.02" height="199.83"/></svg>`;
  private subscriptions: Subscription[] = [];
  public selectedRoute = '';
  public menuOpened: boolean;
  public menuMode: DxDrawerOpenedStateMode = DxDrawerOpenedStateMode.shrink;
  public menuRevealMode: DxDrawerRevealMode = DxDrawerRevealMode.expand;
  public minMenuSize = 0;
  public shaderEnabled = false;
  public tooltipContent: string;
  public target: EventTarget;
  public isDefaultLanguageDe = false;
  public isVisible = false;
  private _selectedItem: string;
  private _temporaryMenuOpened = false;
  public companyName = "";
  public currentUser: GeoDsLoginInfo = new GeoDsLoginInfo(null);
  public dtLogo = `<svg id="Ebene_2" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 450.44 293.73"><defs><style>.cls-1{fill:#fff;}</style></defs><rect class="cls-1" x="217.6" y="164.77" width="25.07" height="64.48"/><rect class="cls-1" x="253.43" y="139.7" width="25.07" height="89.55"/><rect class="cls-1" x="289.25" y="114.62" width="25.07" height="114.63"/><rect class="cls-1" x="325.07" y="152.24" width="25.07" height="77.01"/><rect class="cls-1" x="360.89" y="64.48" width="25.07" height="164.77"/><polygon class="cls-1" points="177.15 172.71 186.33 172.71 186.33 200.95 194.27 200.95 194.27 172.71 203.46 172.71 203.46 164.77 177.15 164.77 177.15 172.71"/><polygon class="cls-1" points="145.39 184.18 134.96 164.77 127.02 164.77 127.02 200.95 134.96 200.95 134.96 181.54 145.39 200.95 153.33 200.95 153.33 164.77 145.39 164.77 145.39 184.18"/><path class="cls-1" d="M119.08,164.78h-7.93v18.08c0,5.78-1,8.09-1.55,9-.26.39-.79,1.19-3.67,1.19s-3.42-.8-3.67-1.19c-.58-.87-1.55-3.18-1.55-9V164.78H92.78v18.08c0,11.51,3.28,18.09,13.15,18.09s13.15-6.58,13.15-18.09Z"/><rect class="cls-1" x="161.27" y="164.78" width="7.94" height="36.17"/><rect class="cls-1" x="64.48" y="215.1" width="14.15" height="14.15"/><rect class="cls-1" x="64.48" y="164.77" width="14.15" height="36.18"/><path class="cls-1" d="M116.82,217.31v11.94h1.77V217.53a.67.67,0,0,1,.67-.66h2.87V215.1H119A2.21,2.21,0,0,0,116.82,217.31Z"/><path class="cls-1" d="M144,215.1h-8a2.21,2.21,0,0,0-2.22,2.2h0V227a2.21,2.21,0,0,0,2.21,2.21h8A2.21,2.21,0,0,0,146.2,227h0v-9.73A2.21,2.21,0,0,0,144,215.1Zm.45,11.72a.67.67,0,0,1-.66.66h-7.53a.67.67,0,0,1-.66-.66v-9.29a.68.68,0,0,1,.66-.66h7.52a.67.67,0,0,1,.67.66Z"/><path class="cls-1" d="M168.44,227.48h-8.18a.67.67,0,0,1-.67-.65h0V215.1h-1.77V227a2.21,2.21,0,0,0,2.21,2.21h10.18V215.1h-1.77Z"/><path class="cls-1" d="M192.06,215.1h-8a2.21,2.21,0,0,0-2.21,2.21h0v17.24h1.77v-5.3H192a2.21,2.21,0,0,0,2.21-2.21v-9.73A2.21,2.21,0,0,0,192.06,215.1Zm.44,11.72a.68.68,0,0,1-.66.66h-8.18v-9.95a.67.67,0,0,1,.66-.66h7.52a.68.68,0,0,1,.66.66Z"/><path class="cls-1" d="M103,215.13h0l-8,0a2.21,2.21,0,0,0-2.21,2.21V227A2.21,2.21,0,0,0,95,229.25h8.44v2.87a.67.67,0,0,1-.67.67H94.55v1.76H103a2.21,2.21,0,0,0,2.21-2.21v-15A2.19,2.19,0,0,0,103,215.13Zm-7.81,12.35a.67.67,0,0,1-.66-.66v-9.29a.67.67,0,0,1,.66-.66h7.51a.67.67,0,0,1,.67.66v9.95Z"/></svg>`;
  public contextMenuItems = [
    {
      text: 'Logout',
      icon: 'assets/images/logout.svg',
      onClick: () => {
        const companyId=localStorage.getItem('companyId');
        localStorage.clear();
        this.menu?.instance.unselectAll();
        this.menu?.instance.selectItem('/customer-history');
        localStorage.removeItem('profileId');
        localStorage.removeItem('userLogin');
        this.dataService.companyName.next("");
        this.userService.clearLoginInfo();
        this.router.navigate(['/login']);
        localStorage.setItem('companyId',companyId);
      }
    }];
  public toastAnimation: IToastAnimation = { show: { type: ToastAnimationShowType.FADE, duration: 400, from: 0, to: 1 } }
  @Input() contextmenuMode: string;
  public languageIsChanged = false;
  public navigation: NavigationMenu[] = []

  constructor(
    private screen: ScreenService,
    private elementRef: ElementRef,
    private userService: UserService,
    private coreDataService: GeoDsCoreDataService,
    public dataService: DataService,
    private router: Router,
    private appService: AppService,
    private cdr: ChangeDetectorRef,
    private resourceManagerService: ResourceManagerService
  ) {
    if (!sessionStorage.getItem('fixedCulture')) {
      sessionStorage.setItem('fixedCulture', 'en');
    }
    if (sessionStorage.getItem('fixedCulture') === 'de') {
      loadMessages(deMessages);
      locale('de');
      this.isDefaultLanguageDe = true;
    } else {
      loadMessages(enMessages);
      locale('en');
      this.isDefaultLanguageDe = false;
    }

    loadMessages({
      'en': {
        'Dt-TreeList-Home': 'Home',
        'Dt-TreeList-Customer-History': 'Customer history',
        'Dt-TreeList-Dashboard': 'Dashboard',
        'Dt-TreeList-Audit': 'Audit',
        'Dt-TreeList-Libraries': 'Libraries',
        'Dt-TreeList-Library': 'Library',
        'Dt-TreeList-Category': 'Category',
        'Dt-TreeList-Question': 'Question',
        'Dt-TreeList-Answer': 'Answer',
        'Dt-TreeList-Measure': 'Measure',
        'Dt-TreeList-Favorite': 'Favorites'

      },
      'de': {
        'Dt-TreeList-Home': 'Home',
        'Dt-TreeList-Customer-History': 'Kundenhistorie',
        'Dt-TreeList-Dashboard': 'Dashboard',
        'Dt-TreeList-Audit': 'Prüfung',
        'Dt-TreeList-Libraries': 'Bibliotheken',
        'Dt-TreeList-Library': 'Bibliothek',
        'Dt-TreeList-Category': 'Kategorie',
        'Dt-TreeList-Question': 'Frage',
        'Dt-TreeList-Answer': 'Antwort',
        'Dt-TreeList-Measure': 'Maßnahme',
        'Dt-TreeList-Favorite': 'Favoriten'
      }
    });

    this.navigation = [
      {
        text: this.dataService.res('Dt-TreeList-Home'),
        component: 'Dt-TreeList-Home',
        path: '/home',
        icon: NavigationSvg.HOME
      },
      {
        text: this.dataService.res('Dt-TreeList-Customer-History'),
        component: 'Dt-TreeList-Customer-History',
        path: '/customer-history',
        icon: NavigationSvg.COMPANY
      },
      {
        text: this.dataService.res('Dt-TreeList-Dashboard'),
        component: 'Dt-TreeList-Dashboard',
        path: '/dashboard',
        icon: NavigationSvg.DASHBOARD
      },
      {
        text: this.dataService.res('Dt-TreeList-Audit'),
        component: 'Dt-TreeList-Audit',
        path: '/audits',

        icon: NavigationSvg.AUDIT
      },
      {
        text: this.dataService.res('Dt-TreeList-Libraries'),
        component: 'Dt-TreeList-Libraries',
        icon: NavigationSvg.LIBRARY,
        isExpanded: false,
        items: [
          {
            text: this.dataService.res('Dt-TreeList-Library'),
            component: 'Dt-TreeList-Library',
            path: '/libraries',
            icon: NavigationSvg.LIBRARY
          },
          {
            text: this.dataService.res('Dt-TreeList-Category'),
            component: 'Dt-TreeList-Category',
            path: '/categories',
            icon: NavigationSvg.MODULE
          },
          {
            text: this.dataService.res('Dt-TreeList-Question'),
            component: 'Dt-TreeList-Question',
            path: '/questions',
            icon: NavigationSvg.TASK
          },
          {
            text: this.dataService.res('Dt-TreeList-Answer'),
            component: 'Dt-TreeList-Answer',
            path: '/responses',
            icon: NavigationSvg.REPORTS
          },
          {
            text: this.dataService.res('Dt-TreeList-Measure'),
            component: 'Dt-TreeList-Measure',
            path: '/measures',
            icon: NavigationSvg.MEASURES
          },
        ]
      },
      {
        text: this.dataService.res('Dt-TreeList-Favorite'),
        component: 'Dt-TreeList-Favorite',
        icon: NavigationSvg.FAVORITE
      },
    ];
  }

  public ngOnInit() {
    this.companyName = localStorage.getItem('companyName');
    this.dataService.companyName$.subscribe((name: string) => {
      this.companyName = name;
    });

    this.subscriptions.push(this.userService.currentUser$.subscribe(user => {
      this.currentUser.displayName = user;
      this.prepareProfileAndCompany().subscribe(data => {
        const profileId: string = data[0][0].Id;
        localStorage.setItem('profileId', profileId);
        this.dataService.cachedStatus = data[1].Data;
        this.dataService.cachedCompaniesTitles = data[2].Data;
      })
    }, error => {
      console.error(error);
    }));

    if ((!this.currentUser.displayName || !localStorage.getItem('profileId')) && localStorage.getItem('refresh_token')) {
      this.subscriptions.push(forkJoin([
        this.userService.getProfileInformations(),
        this.prepareProfileAndCompany()
      ]).subscribe(data => {
        const profileId: string = data[1][0][0].Id;
        this.currentUser.displayName = data[0].DisplayText;
        localStorage.setItem('profileId', profileId);
        this.dataService.cachedStatus = data[1][1].Data;
        this.dataService.cachedCompaniesTitles = data[1][2].Data;
      }, error => {
        console.error(error);
      }));
    }
    this.menuOpened = this.screen.sizes['screen-large'];
    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split('?')[0];
      }
    });
    this.updateDrawer();
    this.screen.changed.subscribe(() => this.updateDrawer());
    this.subscriptions.push(this.appService.notification$.subscribe((notification) => {
      this.dxToast.showNotification(notification);
    }));
    this.subscriptions.push(this.screen.changed.subscribe(() => this.updateDrawer()));
  }

  private prepareProfileAndCompany() {
    const frofileColumns = [(
      this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None)
    )];
    const profileOPath = 'Login=' + "'" + localStorage.getItem('userLogin') + "'";
    return forkJoin([
      this.dataService.readObjects(ObjectKeys.Person, frofileColumns, profileOPath),
      this.dataService.loadListDataSource(ObjectKeys.ADDRESS, "Status"),
      this.dataService.loadListDataSource(ObjectKeys.ADDRESS, "CompanyTitle")
    ]);
  }

  public testChildElement(items, index): any {
    for (let i = index; i > -1; i--) {
      if (items[i]?.items?.length > 0) {
        return [i, index - (i + 1)]
      }
    }
    return 0;
  }

  public changeLanguage = () => {
    this.languageIsChanged = true;
    this.resourceManagerService.changeLanguage(this.languageIsChanged, this.cdr);
    this.isDefaultLanguageDe = this.resourceManagerService.isDefaultLanguageDe;
    location.reload();
  }

  public ngAfterViewInit() {
    this.resourceManagerService.changeLanguage(this.languageIsChanged, this.cdr);
    this.isDefaultLanguageDe = this.resourceManagerService.isDefaultLanguageDe;

    events.on(this.elementRef.nativeElement, 'dxclick', (event: MouseEvent) => {
      this.openMenu.next(event);
    });
  }
  public onContentReady(e): void {
    const elements = e.component.element().querySelectorAll(".dx-treeview-item");
    elements.forEach((el, index) => {
      el.addEventListener("mouseenter", event => {
        const icone = el.querySelector(".dx-icon");
        if (!this.menuOpened) {
          if (e.component._dataAdapter.options.items[index]?.text) {
            this.tooltipContent = e.component._dataAdapter.options.items[index].text;
            this.target = icone;
            this.isVisible = true;
          }
          else if (this.testChildElement(e.component._dataAdapter.options.items, index)) {
            const [parentIndex, childIndex] = this.testChildElement(e.component._dataAdapter.options.items, index);
            const subElement = e.component._dataAdapter.options.items[parentIndex]?.items[childIndex];
            if (subElement.text.length > 0) {
              this.tooltipContent = subElement.text;
              this.target = icone;
              this.isVisible = true;
            }
          }
        }
      });
      el.addEventListener("mouseleave", event => {
        this.isVisible = false;
      });
    });
  }

  private updateDrawer() {
    const isSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];
    this.menuMode = isLarge ? DxDrawerOpenedStateMode.shrink : DxDrawerOpenedStateMode.overlap;
    this.menuRevealMode = isSmall ? DxDrawerRevealMode.slide : DxDrawerRevealMode.expand;
    this.minMenuSize = isSmall ? 0 : 60;
    this.shaderEnabled = !isLarge;
  }

  public toggleMenu = (e) => {
    this.menuOpened = !this.menuOpened;
    e.stopPropagation();
  };

  public isAuthenticated(): boolean {
    if (this.userService.isAuthenticated() && this.selectedRoute !== '/login') {
      return true;
    }
  }

  public onMenuItemClick(event) {
    if (event.itemData.text === this.dataService.res('Dt-TreeList-Favorite')) {
      event.itemElement?.classList.add("favorite");
      this.menu?.instance.unselectAll();
      this.isFavoriteOpen = !this.isFavoriteOpen;
      if (this.isFavoriteOpen) {
        setTimeout(() => {
          this.favorites?.openFavorites();
        });
      } else {
        setTimeout(() => {
          this.favorites?.closeFavorites();
          document.getElementById('container').style.opacity = '1';
        });
      }
    } else {
      const favoriteElement = document.getElementsByClassName('favorite');
      favoriteElement[0]?.classList.remove('favorite');

      this.removeFavoriteItem(event.itemData.text);
      document.getElementById('container').style.opacity = '1';
      this.isFavoriteOpen = false;
    }

    if (this.showMenuAfterClick) {
      this._temporaryMenuOpened = true;
      this.menuOpened = true;
    }
    const path = event.itemData.path;
    const pointerEvent = event.event;
    if (path && this.menuOpened) {
      this.router.navigate([path]);
      this.scrollView?.instance.scrollTo(0);
      if (this.hideMenuAfterNavigation) {
        this._temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent.stopPropagation();
      }
    } else {
      pointerEvent.preventDefault();
    }
    this.menu.instance.selectItem(event.itemData.path);
  }

  @HostListener('document:click', ['$event.target']) onMouseClick(targetElement) {
    const favouritesContainerClicked = document.getElementById('container')?.contains(targetElement);
    const favouritesButtonClicked = document.getElementById('favouritesContainer')?.contains(targetElement);
    if (!favouritesButtonClicked && favouritesContainerClicked) {
      this.favorites?.closeFavorites();
    }
  }

  public removeFavoriteItem(favoriteItem: string): void {
    switch (favoriteItem) {
      case this.dataService.res('Dt-TreeList-Audit'): {
        this.dataService.companyName.next(undefined);
        localStorage.setItem('companyName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Library'): {
        this.dataService.setFavoriteData('library', '');
        localStorage.setItem('libraryName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Category'): {
        this.dataService.setFavoriteData('category', '');
        localStorage.setItem('categoryName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Question'): {
        this.dataService.setFavoriteData('question', '');
        localStorage.setItem('questionName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Answer'): {
        this.dataService.setFavoriteData('answer', '');
        localStorage.setItem('responseName', '');
        break;
      }
      case this.dataService.res('Dt-TreeList-Measure'): {
        this.dataService.setFavoriteData('measure', '');
        localStorage.setItem('measureName', '');
        break;
      }
      default: {
        break;
      }
    }
  }

  public closeFavorites() {
    this.isFavoriteOpen = false;
  }
  public onRouterOutletActivate() {
    this.menu?.instance.selectItem(this.router.url);
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this._temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  public headerMainTitleCSS = (): string => {
    return "header-main-title";
  }

  public ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
